/**
 * Counts spend more
 *
 * @author: Michał Skrzypek <michal[dot]skrzypek[at]studioworx[dot]co[dot]uk>
 */

(function ( $, _ ) { /* global _, JS_TRANSLATIONS, DEBUG, handlebarsTemplates */
	'use strict';

	/**
	 * @selector data-zg-role="spend-more" The plugin start for each selector in the dom when the page load
	 */

	var selector = '[data-zg-role="spend-more"]';

	// RETURN CLASS DEFINITION
	// =======================

	var SpendMore = function ( element, options ) {
		this.$element = $(element);
		this.options = options;
		this._calculateLeftover();
	};

	/**
	 * @param {string} valueContainer container to fill in leftover value
	 * @param {string} totalContainer container containing total value
	 * @param {float} limit to get free shipping
	 */

	SpendMore.DEFAULTS = {
		valueContainer: '[data-zg-role="spend-more-value"]',
		totalContainer: '[data-zg-role="cart-total-noshipcost"]',
		limit: 50.0
	};

	/**
	 * _calculateLeftover
	 */
	SpendMore.prototype._calculateLeftover = function (self) {
		var total = $(this.options.totalContainer).html();
		total = parseFloat(total);
		var diff = this.options.limit - total;
		if ( diff <= 0 ) this.$element.hide();
		else $(this.options.valueContainer, this.$element).html(window.renderPrice(diff));
	};

	// RETURN PLUGIN DEFINITION
	// ========================

	function Plugin ( option ) {
		return this.each( function () {
			var $this = $( this );
			var data = $this.data( 'zg.countdown-timer' );
			var options = $.extend( {}, SpendMore.DEFAULTS, window.ZG_CONFIG || {}, $this.data(), typeof option === 'object' && option );

			if ( !data ) {
				$this.data( 'zg.spend-more', new SpendMore( this, options ) );
			}
		} );
	}

	$.fn.zgSpendMore = Plugin;
	$.fn.zgSpendMore.Constructor = SpendMore;

	// RETURN DATA-API
	// ===============
	
	/**
	 * @method document
	 * @listen document#zg.getProductInfo.productCreated  When product rendered by handlebars (like
	 *     in category page) start the plugin
	 */
	$( document ).on( 'zg.renderProductList', function ( e, element ) {
		if ( $( element ).find( selector ).length ) {
			var $element = $( element ).find( selector );
			Plugin.call( $element );
		}
	} );

	$( function () {
		$( selector ).each( function () {
			Plugin.call( $( this ) );
		} );
	} );

}( jQuery, _ ));
